<template>
  <div class="empty-state-blob">
    <svg class="empty-state-blob__blob-icon" width="100%" height="500px">
      <use href="@/assets/img/empty_dataset.svg#empty_dataset" />
    </svg>
    <SVGIcon
      class="empty-state-blob__empty-icon"
      :iconName="'empty_box'"
      :width="'100%'"
      :height="'200px'"
    />
    <div class="empty-state-blob__message">
      <h3>{{ title }}</h3>
      <p>{{ subtitle }}</p>
    </div>
  </div>
</template>

<script>
import SVGIcon from '@/components/SVGIcon.vue';

export default {
  name: 'EmptyState',
  components: {
    SVGIcon,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.empty-state-blob {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  height: fit-content;
  margin: auto;

  & svg {
    @include themify() {
      fill: themed('color-primary');
    }
  }

  &__empty-icon {
    position: absolute;
    top: 22%;
  }

  &__message {
    text-align: center;
    position: absolute;
    top: 65%;
    @include themify() {
      color: themed('body-text-color');
    }

    h3 {
      margin-bottom: 2px;
    }

    p {
      margin: 0;
      max-width: 500px;
    }
  }
}

@media (max-width: $breakpoint-md) {
  .empty-state-blob {
    padding: 0 16px;
  }

  .empty-state-blob__empty-icon {
    height: 120px;
  }

  .empty-state-blob__blob-icon {
    height: 300px;
  }

  .empty-state-blob__message h3 {
    font-size: 16px;
  }

  .empty-state-blob__message p {
    font-size: 12px;
  }
}

</style>
